<template lang="pug">
v-container
    v-row
        v-col
            v-img#mugshot(v-bind:src="imagePath" :aspect-ratio="2000 / 2997")
            DescriptionSection#descriptions(v-bind:items="descriptionItems")
</template>

<script lang="ts">
import DescriptionSection from '../components/DescriptionSection.vue';
import aboutData from '../data/about';

const Mugshot = new URL('../assets/matthew_swartzendruber.jpg', import.meta.url).href;

export default {
    name: 'About',
    components: {
        DescriptionSection,
    },
    data(): Record<string, unknown> {
        return {
            imagePath: Mugshot,
            descriptionItems: aboutData,
        };
    },
};
</script>

<style lang="scss" scoped>
#mugshot {
    border-radius: 50%;
    width: 200px;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    border: 6px solid #303030;
}

#descriptions {
    margin-top: 20px;
}
</style>
